// The site's look, in the class strings every tool shares (issue 1541, slice 2). The tools were written each with its
// own `btn`, its own header and its own pop-up frame; the same few strings are named here once, so a section header, a
// button, a card or a pop-up reads the same in the Library as in the dice bag. The look itself is `index.css`'s
// components (`vtt-section-head`, `vtt-btn`, `vtt-card`, `vtt-popover`…) over the site's tokens; these strings add the
// Tailwind sizes the tools were written in, so a bar's fit and a finger's 44 px floor (index.css) are as they were.

/** A plain button at a bar's size. */
export const BTN = 'vtt-btn rounded border border-stone-600 px-2 py-0.5 text-xs hover:bg-stone-800 disabled:opacity-50';
/** A plain button in a dialog. */
export const BTN_MD = 'vtt-btn rounded border border-stone-600 px-3 py-1 text-sm hover:bg-stone-800 disabled:opacity-50';
/** The one thing a dialog or a form is for: the gold fill, the dark ink. */
export const PRIMARY = 'vtt-btn-primary rounded border border-amber-600 bg-amber-600 px-3 py-1 text-sm text-stone-950 hover:bg-amber-500 disabled:opacity-50';
/** The same at a bar's size (the dice bag's ROLL, the turn's End turn). */
export const PRIMARY_SM = 'vtt-btn-primary rounded border border-amber-600 bg-amber-600 px-2 py-0.5 text-xs text-stone-950 hover:bg-amber-500 disabled:opacity-50';
/** A section's header inside a tool: uppercase 11.5 px, 0.07em apart. */
export const SECTION_HEAD = 'vtt-section-head';
/** A title in the frame's gold Cinzel: a dialog's, a pop-up's. */
export const TITLE = 'vtt-title';
/** The same in capitals, as the bars' titles are: the roll log's header. */
export const TITLE_CAPS = 'vtt-title-caps';
/** A card inside a bar. */
export const CARD = 'vtt-card';
/** A pop-up over the table: a menu, a dialog, a hover card. */
export const POPOVER = 'vtt-popover shadow-xl';
